export const stripDownloadSuffix = id => (id ? id.replace(/\/download$/, "") : id);
